var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/well-known-symbol-wrapped.js
// module id = 133
// module chunks = 0 1 2 4 6 7 10 11 13 18 22 30 35